import { render, staticRenderFns } from "./MembrePreResa.vue?vue&type=template&id=36dcb1cc&scoped=true&"
import script from "./MembrePreResa.vue?vue&type=script&lang=js&"
export * from "./MembrePreResa.vue?vue&type=script&lang=js&"
import style0 from "./MembrePreResa.vue?vue&type=style&index=0&id=36dcb1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dcb1cc",
  null
  
)

export default component.exports